module.exports = {"141126100":"灵泉镇","141126101":"罗村镇","141126102":"义牒镇","141126103":"小蒜镇","141126200":"龙交乡","141126201":"和合乡","141126202":"前山乡","141126203":"曹家垣乡","141126204":"裴沟乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141126.json
// module id = 384
// module chunks = 0